import clsx from "clsx";
import parse from "html-react-parser";
import Image from 'next/image';

import SocialLinks from "@components/SocialLinks";
import IImage from "@sharedInterfaces/Image.interface";

interface IProps {
  heading: string;
  image: IImage;
  imageBlur: IImage;
  socialLinks?: any;
  role?: string;
  biography?: string;
  aspectRatio?: 'square' | 'responsive';
}

const Profile = ({
  heading,
  image,
  imageBlur,
  socialLinks,
  role,
  biography,
  aspectRatio = 'square'
}: IProps) => {
  return (
    <div className={clsx("Profile", "max-w-screen-xl mx-auto")}>
      <div
        className={clsx(
          "Profile__content",
          "flex flex-col lg:flex-row",
          "mx-auto",
          "px-7.5 md:px-5 lg:px-5"
        )}
      >
        <div
          className={clsx(
            "Profile__imageWrapper",
            "relative",
            "lg:w-1/3",
            "mb-4",
          )}
        >
          {!!image?.url && (
            <div
            className={clsx({
              "aspect-w-1 aspect-h-1" : aspectRatio === 'square'
            })}
          >
              <Image
                src={image.url}
                alt={image.title}
                layout={aspectRatio === 'square' ? "fill" : "responsive"}
                width={aspectRatio != 'square' && image.width}
                height={aspectRatio != 'square' && image.height}
                objectPosition={aspectRatio === 'square' && "top"}
                placeholder="blur"
                blurDataURL={imageBlur.url}
                className={clsx("Profile__image")}
              />
            </div>
          )}
          {!image && (
            <div
              className={clsx("aspect-w-16 aspect-h-10", "bg-white-03")}
            ></div>
          )}
        </div>

        <div className={clsx("Profile__body", "lg:w-2/3", "lg:pl-7.5")}>
          <div className={clsx("Profile__header", "mb-7.5")}>
            <h1
              className={clsx(
                "Profile__heading",
                "text-2xl lg:text-4xl",
                "mb-2"
              )}
            >
              {heading}
            </h1>
            {!!role && (
              <div className={clsx("Profile__role", "mb-4 lg:mb-7.5")}>
                {role}
              </div>
            )}
            {!!socialLinks && (
              <div className={clsx("Profile__socialLinks")}>
                <SocialLinks links={socialLinks} />
              </div>
            )}
          </div>
          {!!biography && (
            <div className={clsx("Profile__biography", "prose")}>
              {parse(biography)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
